import { createWebHistory, createRouter } from 'vue-router'

import axios from 'axios'
import routes from './routes'
import appConfig from '../../app.config'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0, left: 0 }
    }
  },
})

router.beforeEach(async (routeTo, routeFrom, next) => {
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)

  if (!authRequired) return next()

  axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')

  await axios
    .post( appConfig.baseURL + '/login/user/u103')
    .then((data) => {
      localStorage.setItem('userdata', JSON.stringify(data.data.cmmData))
      localStorage.setItem('userid'  , data.data.cmmData.userId)
      localStorage.setItem('userName', data.data.cmmData.userNm)
      //localStorage.setItem('userDesc', data.data.cmmData.description)
      localStorage.setItem('userDesc', data.data.cmmData.deptId)
      localStorage.setItem('userType', data.data.cmmData.userType)
      localStorage.setItem('user', JSON.stringify(data.data.cmmData))
      next()
    })
    .catch((e) => {
      console.log('router.beforeEach>>>catch>>>>>>', e)
      next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
    })
})

router.beforeEach((routeTo, routeFrom, next) => {
  const publicPages = ['/login', '/register', '/forgot-password']
  const authpage = !publicPages.includes(routeTo.path)
  const loggeduser = localStorage.getItem('user')

  if (authpage && !loggeduser) {
    return next('/login')
  }

  next()
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    }
  } catch (error) {
    return
  }
  document.title = routeTo.meta.title + ' | ' + appConfig.title

  next()
})

export default router
